import InputSearchAdvanced from './InputSearchAdvanced'
export default InputSearchAdvanced;